import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Label } from 'reactstrap';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import PropTypes from 'prop-types';
import useAxios from '../../hooks/useAxios';
import { showToast } from '../../components/toast/Toast';

const FormTimeOffManualAdmin = ({
  objectData,
  setObjectData,
  setRequester,
  setApprover,
  setRequesterDelegate,
  customStyles,
}) => {
  const animatedComponents = makeAnimated();
  const api = useAxios();

  const { isLoading, data } = useQuery({
    queryKey: ['employee-options'],
    queryFn: () =>
      api.get(`/employee/option-list`).then((res) => {
        return res.data.data;
      }),
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file && file.type !== 'application/pdf') {
      showToast('File harus berekstensi .pdf', 'error');
      e.target.value = ''; // reset file input
    } else {
      setObjectData({ ...objectData, attachment: file });
    }
  };

  return (
    <div className="d-flex flex-column gap-3 border border-primary bg-light-secondary rounded-4 p-3">
      <div className="form-group">
        <Label htmlFor="requester">Karyawan yang Mengajukan</Label>
        <Select
          id="requester"
          styles={customStyles}
          options={data}
          isLoading={isLoading}
          components={animatedComponents}
          onChange={(choice) => setRequester(choice)}
        />
      </div>
      <div className="form-group">
        <Label htmlFor="approver">Telah Disetejui oleh</Label>
        <Select
          id="approver"
          styles={customStyles}
          options={data}
          isLoading={isLoading}
          components={animatedComponents}
          onChange={(choice) => setApprover(choice)}
        />
      </div>
      <div className="form-group d-flex flex-column">
        <Label htmlFor="attach">Lampiran (Bukti scan form manual)</Label>
        <input
          type="file"
          className="form-control rounded-4"
          accept=".pdf"
          id="attach"
          onChange={(e) => handleFileChange(e)}
        />
        <small className="text-primary" style={{ marginTop: '3px', fontSize: '12px' }}>
          File harus berekstensi .pdf (Maks. 20mb)
        </small>
      </div>
      <div className="form-group">
        <Label htmlFor="delegate">Delegasi</Label>
        <Select
          id="delegate"
          styles={customStyles}
          options={data}
          isLoading={isLoading}
          components={animatedComponents}
          onChange={(choice) => setRequesterDelegate(choice)}
        />
      </div>
    </div>
  );
};

FormTimeOffManualAdmin.propTypes = {
  setObjectData: PropTypes.func,
  objectData: PropTypes.object,
  setRequester: PropTypes.func,
  setApprover: PropTypes.func,
  setRequesterDelegate: PropTypes.func,
  customStyles: PropTypes.object,
};

export default FormTimeOffManualAdmin;
